import { MapPin, Flag } from "lucide-react";
import { t } from "@/lib/i18n";

export default function FilterLocation({ kind, filters, setFilters, meta, areas }) {
  const Icon = kind === "loading" ? MapPin : Flag;
  const country = filters[`${kind}_country`];
  const regions = meta.regions?.[country] || [];
  const set = (k) => (e) => setFilters({ ...filters, [`${kind}_${k}`]: e.target.value, ...(k === "country" ? { [`${kind}_region`]: "" } : {}) });
  const short = kind === "loading" ? "origin" : "destination";
  return (
    <fieldset className="space-y-2" data-testid={`filter-${kind}-location`}>
      <legend className="hf-label flex items-center gap-1.5"><Icon className="w-3.5 h-3.5 text-amber-600" /> {kind === "loading" ? t("Loading point") : t("Offloading point")}</legend>
      <select value={country} onChange={set("country")} className="hf-input" data-testid={`select-filter-${short}-country`}>
        <option value="">{t("All countries")}</option>
        {meta.countries.map((c) => <option key={c.name} value={c.name}>{c.name}</option>)}
      </select>
      <select value={filters[`${kind}_region`]} onChange={set("region")} disabled={!regions.length} className="hf-input disabled:bg-slate-50 disabled:text-slate-400" data-testid={`select-filter-${short}-region`}>
        <option value="">{country && !regions.length ? t("Not applicable") : t("All provinces / regions")}</option>
        {regions.map((r) => <option key={r} value={r}>{r}</option>)}
      </select>
      <input list={`${kind}-areas`} value={filters[`${kind}_area`]} onChange={set("area")} placeholder={t("Town / area (optional)")} className="hf-input" data-testid={`input-filter-${short}`} />
      <datalist id={`${kind}-areas`}>{(areas[kind] || []).map((a) => <option key={a} value={a} />)}</datalist>
    </fieldset>
  );
}
